/**
 * Entrance variants. Each section picks a different one so headings
 * don't all arrive the same way as you scroll the page.
 */
export type HeadingAnim =
  | 'rise'
  | 'fade'
  | 'slide'
  | 'zoom'
  | 'blur'
  | 'wipe'
  | 'float'
  | 'drop'
  | 'glide';

interface SectionHeadingProps {
  title: React.ReactNode;
  lede?: React.ReactNode;
  anim?: HeadingAnim;
}

export function SectionHeading({
  title,
  lede,
  anim = 'rise',
}: SectionHeadingProps): React.JSX.Element {
  return (
    <div className={`section-head sh-${anim} reveal`}>
      <h2 className="h2">{title}</h2>
      {lede && <p className="lede">{lede}</p>}
    </div>
  );
}
